import { useState, useEffect, useRef } from "react";
import "../../styles/tombola.css";
import classNames from "classnames";
import { AnimatedLoader } from "../../components/utilities/loader-anim";


export const TicketRegistration = () => {
    const serverUrl = window.location.origin === "http://localhost:3000" ?
    "http://localhost/tombola" : "tombola"
    const nameRef = useRef();
    const numRef = useRef();

    const [apiData, setApiData] = useState({
        names: '',
        ticketNumber: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const isFilled = (v) =>{
        return ( v !== '' && v !== undefined && v !== null )
    };


    useEffect(() => {
        const randomCode = Math.random().toString(36).slice(2, 8).toUpperCase();
        setApiData((data) => ({ ...data, ticketNumber: randomCode }));
    }, [])

    const submitTicket = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${serverUrl}/ticket/create`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(apiData),
                mode: "cors"
            });
            const res = await response.json();
            console.log(res);
            alert(res?.message);
            window.location.reload();
        } catch (error) {
            console.log({error});
        }finally{
            setIsLoading(false);
        }
    }

    return (
        <div className="cntr-page">
            {isLoading && <AnimatedLoader />}
            <form action="" className="reg-form">
                <div className="reg-caption">Register Tombola Entry</div>
                <div className="reg-input-container">
                    <label 
                        htmlFor="names" 
                        className={classNames("input-label",{'top': isFilled(apiData?.names)} )}
                    >
                        Names
                    </label>
                    <input
                        type="text"
                        className="reg-input"
                        id="names"
                        required
                        ref={nameRef}
                        onChange={(e) => {
                            e.preventDefault();
                            setApiData((d) => ({...d, names: e.target.value}))
                        }}
                    />
                </div>
                <div className="reg-input-container">
                    <label 
                        htmlFor="number" 
                         className={classNames("input-label",{'top': isFilled(apiData?.ticketNumber)} )}
                    >
                        Ticket Number
                    </label>
                    <input
                        type="text"
                        value={apiData?.ticketNumber}
                        className="reg-input"
                        id="number"
                        required
                        ref={numRef}
                    />
                </div>
                <div className="submit-button-box">
                    <button 
                        className="submit-reg"
                        onClick={async (e) => {
                            e.preventDefault();
                            await submitTicket();
                        }}
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
    )
}